import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46a1f06e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pixel-stage-viewport" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "pixel-gap-mask",
  viewBox: "0 0 320 180",
  preserveAspectRatio: "xMidYMid meet",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("pattern", {
      id: "pixel-rounded-gap",
      width: "1",
      height: "1",
      patternUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0 0H1V1H0Z M.25.1H.75A.15.15 0 0 1 .9.25V.75A.15.15 0 0 1 .75.9H.25A.15.15 0 0 1 .1.75V.25A.15.15 0 0 1 .25.1Z",
        fill: "#07141c",
        "fill-opacity": ".48",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "320",
    height: "180",
    fill: "url(#pixel-rounded-gap)"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<g class=\"lamp-glow\" fill=\"#f0bd67\" data-v-46a1f06e><rect width=\"320\" height=\"180\" fill=\"#b86d3d\" opacity=\".035\" data-v-46a1f06e></rect><path d=\"M93 18H99L236 180H-44Z\" opacity=\".065\" data-v-46a1f06e></path><path d=\"M221 18H227L364 180H84Z\" opacity=\".065\" data-v-46a1f06e></path><rect x=\"128\" y=\"84\" width=\"181\" height=\"2\" opacity=\".14\" data-v-46a1f06e></rect><rect x=\"42\" y=\"115\" width=\"258\" height=\"3\" opacity=\".12\" data-v-46a1f06e></rect><rect x=\"86\" y=\"123\" width=\"176\" height=\"2\" opacity=\".08\" data-v-46a1f06e></rect><rect x=\"92\" y=\"14\" width=\"8\" height=\"5\" fill=\"#fff0bd\" opacity=\".72\" data-v-46a1f06e></rect><rect x=\"220\" y=\"14\" width=\"8\" height=\"5\" fill=\"#fff0bd\" opacity=\".72\" data-v-46a1f06e></rect></g>", 1)
const _hoisted_4 = [
  _hoisted_3
]

import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import type { Appearance, BarEvent, IslandWeather, Recipe } from './types'
import { createIslander3Sprite } from './islander3Sprite'
import { createIslander4HandLayer, createIslander4LayerBaseSprite } from './islander4Sprite'
import {
  createIslander5HandLayer, createIslander5Sprite, createIslander6Sprite, createIslander7Sprite,
  createIslander8ShakeBaseSprite, createIslander8ShakeHandLayer,
} from './islanderActionSprites'


export default /*#__PURE__*/_defineComponent({
  props: {
    cue: null,
    recipe: null,
    appearance: null,
    localHour: null,
    weather: null,
    barMode: null,
    bartenderPresent: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  cue: BarEvent | null
  recipe: Recipe | null
  appearance: Appearance | null
  localHour: number
  weather: IslandWeather | null
  barMode: 'open' | 'stocking' | 'closed'
  bartenderPresent: boolean
}



const canvas = ref<HTMLCanvasElement | null>(null)
let context: CanvasRenderingContext2D | null = null
let frame = 0
let startedAt = performance.now()
let actionStartedAt = 0
let actionDuration = 1200
let action = 'idle'
let ingredientType = 0
let raf = 0
let islanderSprite: HTMLCanvasElement | null = null
let islanderLayerSprite: HTMLCanvasElement | null = null
let islanderLayerHandLayer: HTMLCanvasElement | null = null
let islanderStirSprite: HTMLCanvasElement | null = null
let islanderStirHandLayer: HTMLCanvasElement | null = null
let islanderShakeSprite: HTMLCanvasElement | null = null
let islanderShakeHandLayer: HTMLCanvasElement | null = null
let islanderBottleSprite: HTMLCanvasElement | null = null
let islanderItemSprite: HTMLCanvasElement | null = null
let resultQueued = false

const TECHNIQUE_ACTIONS = new Set(['shake', 'stir', 'muddle', 'layer'])
const BOTTLED_INGREDIENTS = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 16, 17, 20])

const P = {
  ink: '#07141c', ink2: '#102631', sea: '#174456', sea2: '#1d6071', foam: '#8cc8c2',
  rain: '#438091', wall: '#17242a', wall2: '#27353a', wood0: '#261719', wood1: '#4d2927',
  wood2: '#76422f', wood3: '#a6673f', brass0: '#76502e', brass1: '#c08a48', lamp: '#f0bd67',
  skin0: '#713b32', skin1: '#c8795e', skin2: '#efaa7b', hair0: '#0b526c', hair1: '#218da9', hair2: '#71d6d8',
  apron0: '#173846', apron1: '#236175', apron2: '#4992a0', coral: '#d85e4a', white: '#e9dfc8',
  blue0: '#075b8e', blue1: '#0a9ed0', blue2: '#65d7dd', tail0: '#075b73', tail1: '#1595a3', tail2: '#74d8ce', honey: '#d8952e', green: '#5b9b62',
}

// Set this to false to restore the recorded clean, flat-color baseline.
const COLOR_DITHER_ENABLED = true
// Set only this switch to false to keep the environment texture but restore the recorded clean character.
const CHARACTER_DITHER_ENABLED = false
const BAYER_4 = [
  [0, 8, 2, 10],
  [12, 4, 14, 6],
  [3, 11, 1, 9],
  [15, 7, 13, 5],
]

const recipes: Record<number, { liquid: string; accent: string }> = {
  1: { liquid: '#e68a4d', accent: '#f4c16c' },
  2: { liquid: P.blue1, accent: P.blue2 },
  3: { liquid: '#57a66a', accent: '#9bd27b' },
  4: { liquid: '#e3a234', accent: '#f5d26a' },
  5: { liquid: '#a85c32', accent: '#e3a04e' },
}

function rect(x: number, y: number, w: number, h: number, color: string) {
  if (!context) return
  context.fillStyle = color
  context.fillRect(Math.round(x), Math.round(y), Math.round(w), Math.round(h))
}

function clamp01(value: number) {
  return Math.max(0, Math.min(1, value))
}

function mixColor(from: string, to: string, amount: number) {
  const ratio = clamp01(amount)
  const read = (color: string, offset: number) => parseInt(color.slice(offset, offset + 2), 16)
  const channel = (offset: number) => Math.round(read(from, offset) + (read(to, offset) - read(from, offset)) * ratio)
  return `#${[channel(1), channel(3), channel(5)].map(value => value.toString(16).padStart(2, '0')).join('')}`
}

function daylightAmount() {
  if (props.localHour <= 5 || props.localHour >= 20) return 0
  return Math.sin(((props.localHour - 5) / 15) * Math.PI)
}

function drawTranslatedIslander(t: number) {
  const scale = 2
  const verticalOffset = Math.round(64 / 3)
  const elapsed = Math.max(0, t - actionStartedAt)
  const progress = Math.min(1, elapsed / Math.max(1, actionDuration))
  const breath = Math.round(Math.sin(t * .0021 + .45))
  let bodyX = 0
  let headX = 0
  let tailX = Math.round(Math.sin(t * .0025) * 2)
  let actionY = 0

  // Each WS cue gets its own readable silhouette. Motion stays on the integer
  // pixel grid: the sprite is bent row-by-row instead of smoothly rotated.
  if (action === 'accept') {
    actionY = -Math.round(Math.sin(progress * Math.PI) * 3)
    headX = -Math.round(Math.sin(progress * Math.PI) * 2)
  } else if (action === 'talk') {
    headX = Math.round(Math.sin(t * .009) * 2)
  } else if (action === 'ingredient') {
    const reach = Math.sin(progress * Math.PI)
    bodyX = -Math.round(reach * 2)
    headX = -Math.round(reach * 4)
    actionY = -Math.round(reach)
  } else if (action === 'stir') {
    bodyX = Math.round(Math.cos(t * .012) * 2)
    headX = bodyX + 1
    actionY = Math.round(Math.sin(t * .012))
  } else if (action === 'muddle') {
    actionY = Math.round(Math.abs(Math.sin(t * .024)) * 2)
    headX = -1
  } else if (action === 'serve') {
    const lean = Math.sin(progress * Math.PI * .5)
    bodyX = -Math.round(lean * 2)
    headX = -Math.round(lean * 4)
  } else if (action === 'result') {
    const greeting = Math.max(0, 1 - elapsed / 900)
    actionY = -Math.round(Math.abs(Math.sin(elapsed * .013)) * 3 * greeting)
    tailX = Math.round(Math.sin(t * .009) * 4)
  } else if (action === 'failed') {
    actionY = 2
    headX = -2
    tailX = 1
  }

  const originX = 142
  const originY = 6 + verticalOffset + breath + actionY
  let activeSprite = islanderSprite
  if (action === 'ingredient') activeSprite = BOTTLED_INGREDIENTS.has(ingredientType) ? islanderBottleSprite : islanderItemSprite
  else if (action === 'shake') activeSprite = islanderShakeSprite
  else if (action === 'stir') activeSprite = islanderStirSprite
  else if (action === 'layer') activeSprite = islanderLayerSprite
  if (!context || !activeSprite) return
  for (let sourceY = 0; sourceY < 64; sourceY++) {
    let rowX = bodyX
    if (sourceY < 28) rowX = headX
    else if (sourceY < 44) rowX = Math.round(headX + (bodyX - headX) * ((sourceY - 28) / 16))
    else rowX = Math.round(bodyX + (tailX - bodyX) * ((sourceY - 44) / 20))
    context.drawImage(activeSprite, 0, sourceY, 64, 1, originX + rowX * scale, originY + sourceY * scale, 64 * scale, scale)
  }
  if (action === 'stir' && islanderStirHandLayer) {
    const handX = Math.round(Math.sin(t * .022))
    const handY = Math.round(Math.cos(t * .022))
    context.drawImage(islanderStirHandLayer, 15, 30, 11, 7, originX + (15 + bodyX + handX) * scale, originY + (30 + handY) * scale, 11 * scale, 7 * scale)
  } else if (action === 'shake' && islanderShakeHandLayer) {
    const handX = Math.round(Math.sin(t * .055) * 2)
    const handY = Math.round(Math.cos(t * .055))
    context.drawImage(islanderShakeHandLayer, originX + handX * scale, originY + handY * scale, 64 * scale, 64 * scale)
  } else if (action === 'layer' && islanderLayerHandLayer) {
    const handY = Math.round(Math.sin(t * .008) * 2)
    context.drawImage(islanderLayerHandLayer, originX, originY + handY * scale, 64 * scale, 64 * scale)
  }
  if (!TECHNIQUE_ACTIONS.has(action)) drawIslanderActionProp(t, originX, originY)
}

function drawIslanderActionProp(t: number, originX: number, originY: number) {
  const centerX = originX + 64
  const handY = originY + 71
  if (action === 'accept') {
    const sparkle = Math.floor(t / 130) % 2
    rect(centerX + 35, originY + 17, 2, 5 + sparkle * 2, P.lamp)
    rect(centerX + 33 - sparkle, originY + 19 + sparkle, 6 + sparkle * 2, 2, P.lamp)
  } else if (action === 'result') {
    const sparkle = Math.floor(t / 180) % 3
    rect(centerX - 48, handY - 16 - sparkle, 2, 5, P.lamp)
    rect(centerX - 50, handY - 14 - sparkle, 6, 2, P.lamp)
  }
}

function ditherRect(x: number, y: number, w: number, h: number, color: string, density: number, phaseX = 0, phaseY = 0) {
  if (!COLOR_DITHER_ENABLED || !context) return
  context.fillStyle = color
  context.beginPath()
  for (let py = 0; py < h; py++) {
    for (let px = 0; px < w; px++) {
      if (BAYER_4[(py + phaseY) & 3][(px + phaseX) & 3] < density) {
        context.rect(x + px, y + py, 1, 1)
      }
    }
  }
  context.fill()
}

function characterDitherRect(x: number, y: number, w: number, h: number, color: string, density: number, phaseX = 0, phaseY = 0) {
  if (!CHARACTER_DITHER_ENABLED) return
  ditherRect(x, y, w, h, color, density, phaseX, phaseY)
}

function pixelText(text: string, x: number, y: number, color = P.white, align: CanvasTextAlign = 'left') {
  if (!context) return
  context.font = '7px monospace'
  context.textAlign = align
  context.textBaseline = 'top'
  context.fillStyle = P.ink
  context.fillText(text, x + 1, y + 1)
  context.fillStyle = color
  context.fillText(text, x, y)
}

function drawWindow(t: number) {
  const daylight = daylightAmount()
  const cloudiness = clamp01(props.weather?.cloudiness ?? .15)
  const precipitation = clamp01(props.weather?.precipitation ?? 0)
  const waveLevel = clamp01(props.weather?.wave_level ?? .15)
  const wind = Math.max(1, props.weather?.wind_speed_mps ?? 2)
  const sky = mixColor('#0a1d2a', '#6099a5', daylight * (1 - cloudiness * .42))
  const horizon = mixColor('#123849', '#9ab8ae', daylight * (1 - cloudiness * .25))
  rect(8, 8, 111, 82, P.ink)
  rect(11, 11, 105, 76, P.ink2)
  rect(12, 12, 103, 45, sky)
  rect(12, 57, 103, 29, mixColor(P.sea, '#397986', daylight * .45))
  rect(12, 64, 103, 4, P.sea2)
  rect(12, 76, 103, 2, '#286b77')
  ditherRect(12, 12, 103, 45, horizon, Math.max(1, Math.round(4 - cloudiness * 3)), 1)
  ditherRect(12, 57, 103, 29, '#286b77', 3, 0, 1)
  for (let x = 12; x < 115; x += 13) {
    const wave = Math.round(Math.sin(t * (.0014 + wind * .00008) + x) * (1 + waveLevel * 3))
    rect(x, 62 + wave, 8, 1, P.foam)
  }
  // Sun and moon follow the viewer's local clock, independent of island weather.
  if (daylight > .04) {
    const travel = clamp01((props.localHour - 5) / 15)
    const sunX = Math.round(18 + travel * 87)
    const sunY = Math.round(43 - daylight * 25)
    rect(sunX - 2, sunY - 2, 5, 5, mixColor('#df8354', '#f7d87a', daylight))
  } else {
    const nightProgress = props.localHour >= 20 ? (props.localHour - 20) / 9 : (props.localHour + 4) / 9
    const moonX = Math.round(18 + clamp01(nightProgress) * 87)
    const moonY = Math.round(38 - Math.sin(clamp01(nightProgress) * Math.PI) * 17)
    rect(moonX - 2, moonY - 2, 5, 5, '#d8ddd2')
    rect(moonX, moonY - 2, 3, 3, sky)
  }
  // Clouds remain blocky and grow denser from the continuous weather value.
  const cloudCount = Math.round(cloudiness * 5)
  for (let i = 0; i < cloudCount; i++) {
    const x = 15 + ((i * 29 + Math.floor(t * wind / 9000)) % 92)
    const y = 18 + (i * 11) % 27
    const cloud = mixColor('#30424a', '#d2d1bd', daylight * .72)
    rect(x, y, 13, 3, cloud)
    rect(x + 3, y - 2, 7, 2, cloud)
  }
  // Lighthouse and its clockwise 360-degree sweep.
  rect(72, 42, 7, 22, '#c7bba2')
  rect(70, 40, 11, 3, P.ink)
  rect(73, 37, 5, 4, P.lamp)
  rect(74, 33, 3, 4, P.ink)
  if (context) {
    // A rotating lamp seen from shore is a horizontal projection: the beam
    // contracts into the lens, then grows from the opposite side.
    const projection = Math.sin(t * .00052)
    const visible = Math.abs(projection)
    const reach = projection < 0 ? 64 : 39
    const paintBeam = (lengthScale: number, width: number, alpha: number) => {
      if (visible < .025) return
      const tipX = 76 + projection * reach * lengthScale
      const projectedWidth = Math.max(1, Math.round(width * (.3 + visible * .7)))
      context!.globalAlpha = alpha
      context!.fillStyle = P.lamp
      context!.beginPath()
      context!.moveTo(74, 38)
      context!.lineTo(Math.round(tipX), 39 - projectedWidth)
      context!.lineTo(Math.round(tipX), 39 + projectedWidth)
      context!.lineTo(78, 40)
      context!.closePath()
      context!.fill()
    }
    context.save()
    context.beginPath()
    context.rect(12, 12, 103, 74)
    context.clip()
    context.globalCompositeOperation = 'screen'
    paintBeam(1, 32, .075)
    paintBeam(.88, 14, .14)
    context.restore()
  }
  rect(48, 8, 3, 82, P.ink)
  rect(8, 49, 111, 3, P.ink)
  rect(9, 9, 108, 2, P.wood2)
  // Rain density comes from the shared island weather timeline.
  const rainCount = Math.round(precipitation * 38)
  for (let i = 0; i < rainCount; i++) {
    const x = 13 + ((i * 37 + Math.floor(t / 46) * 2) % 100)
    const y = 13 + ((i * 23 + Math.floor(t / 26) * 3) % 70)
    rect(x, y, 1, 3, P.rain)
    rect(x - 1, y + 3, 1, 1, P.rain)
  }
  if ((props.weather?.visibility_km ?? 30) <= 4 && context) {
    context.globalAlpha = .18
    rect(12, 12, 103, 74, '#bac8c1')
    context.globalAlpha = 1
  }

  // Keep the first weather implementation local to the view outside: a small
  // pane readout confirms which shared-island weather the scenery is showing.
  if (props.weather) {
    const temperature = Math.round(props.weather.temperature_c)
    const weatherLabel = `${props.weather.condition_name} ${temperature}°`
    rect(54, 13, 59, 12, P.ink)
    rect(56, 15, 55, 8, '#17313a')
    pixelText(weatherLabel, 59, 16, P.white)
  }
}

function bottle(x: number, y: number, color: string, label = P.white, h = 22) {
  rect(x + 3, y, 4, 4, P.ink)
  rect(x + 2, y + 4, 6, 3, color)
  rect(x, y + 7, 10, h - 7, P.ink)
  rect(x + 1, y + 8, 8, h - 9, color)
  rect(x + 2, y + 13, 6, 5, label)
  rect(x + 3, y + 14, 4, 3, P.ink2)
  rect(x + 2, y + 8, 1, 4, P.white)
}

function drawBackBar() {
  rect(121, 0, 199, 105, P.wall)
  rect(126, 8, 184, 78, P.wall2)
  rect(130, 12, 176, 70, '#1b2529')
  ditherRect(130, 12, 176, 70, P.wall2, 2, 2, 1)
  rect(132, 36, 172, 3, P.wood2)
  rect(132, 70, 172, 3, P.wood2)
  bottle(138, 15, '#87512f')
  bottle(154, 12, P.blue1, P.blue2, 25)
  bottle(171, 17, '#486f50')
  bottle(281, 13, '#9d6534', P.honey, 24)
  bottle(263, 17, '#7b3340')
  bottle(246, 12, '#d7d0af', P.blue2, 25)
  bottle(134, 44, '#c59537', P.honey, 25)
  bottle(151, 48, '#627b48')
  bottle(281, 46, '#694331', P.white, 24)
  bottle(263, 43, '#7aa2a3', P.white, 27)
  rect(214, 17, 20, 16, P.ink)
  rect(216, 19, 16, 12, '#aa7741')
  rect(220, 21, 8, 1, P.white)
  rect(220, 25, 9, 1, P.white)
  rect(220, 29, 6, 1, P.white)
  rect(129, 84, 180, 3, P.wood0)
  rect(124, 87, 190, 18, P.wood1)
  for (let x = 130; x < 310; x += 22) rect(x, 91, 15, 2, P.wood2)
}

function drawBartender(t: number) {
  const elapsed = Math.max(0, t - actionStartedAt)
  const progress = Math.min(1, elapsed / actionDuration)
  const shaking = action === 'shake'
  const stirring = action === 'stir' || action === 'muddle'
  const layering = action === 'layer'
  const pouring = action === 'ingredient'
  const serving = action === 'serve'
  // A mermaid's body keeps a slow buoyant rise and fall through every bar action.
  const bob = Math.round(Math.sin(t * .0021 + .45) * 2)
  const shakeX = shaking ? Math.round(Math.sin(t * .035) * 3) : 0
  const bx = 205 + shakeX
  const by = 42 + bob

  // Fox ears: stepped silhouettes keep the ears sharp at 320×180.
  rect(bx - 16, by - 5, 5, 7, P.hair0)
  rect(bx - 14, by - 10, 5, 9, P.hair0)
  rect(bx - 11, by - 6, 4, 7, P.hair1)
  rect(bx - 12, by - 7, 2, 4, P.coral)
  rect(bx + 10, by - 5, 5, 7, P.hair0)
  rect(bx + 8, by - 10, 5, 9, P.hair0)
  rect(bx + 6, by - 6, 4, 7, P.hair1)
  rect(bx + 9, by - 7, 2, 4, P.coral)

  // Water-blue long hair, with a stepped oval crown instead of a square cap.
  rect(bx - 10, by + 1, 21, 3, P.hair0)
  rect(bx - 14, by + 3, 29, 4, P.hair0)
  rect(bx - 17, by + 6, 35, 41, P.hair0)
  rect(bx - 20, by + 13, 7, 59, P.hair1)
  rect(bx - 18, by + 45, 5, 33, P.hair2)
  rect(bx + 14, by + 12, 8, 61, P.hair1)
  rect(bx + 17, by + 43, 5, 35, P.hair2)
  rect(bx - 14, by + 58, 4, 17, P.hair0)
  rect(bx + 11, by + 57, 4, 20, P.hair0)
  // Hair carries the richest character dithering, anchored to bx/by so it never crawls while she moves.
  characterDitherRect(bx - 15, by + 7, 31, 38, P.hair1, 2, 1, 2)
  characterDitherRect(bx - 20, by + 14, 7, 57, P.hair2, 2, 3, 1)
  characterDitherRect(bx + 14, by + 13, 8, 58, P.hair2, 2, 0, 2)
  // A softly tapered oval face: rounded cheeks and a wider, curved chin.
  rect(bx - 10, by + 8, 22, 3, P.skin1)
  rect(bx - 12, by + 11, 26, 5, P.skin1)
  rect(bx - 13, by + 16, 28, 8, P.skin1)
  rect(bx - 12, by + 24, 26, 6, P.skin1)
  rect(bx - 10, by + 30, 22, 5, P.skin1)
  rect(bx - 6, by + 35, 14, 3, P.skin1)
  rect(bx - 4, by + 38, 10, 1, P.skin1)
  rect(bx - 8, by + 10, 18, 3, P.skin2)
  rect(bx - 10, by + 13, 22, 5, P.skin2)
  rect(bx - 11, by + 18, 24, 6, P.skin2)
  rect(bx - 10, by + 24, 22, 6, P.skin2)
  rect(bx - 8, by + 30, 18, 4, P.skin2)
  rect(bx - 5, by + 34, 12, 3, P.skin2)
  rect(bx - 3, by + 37, 8, 1, P.skin2)
  // Sparse cheek-edge pixels add warmth without dirtying the eyes, mouth or forehead.
  characterDitherRect(bx - 11, by + 23, 4, 10, P.skin1, 1, 1, 0)
  characterDitherRect(bx + 8, by + 24, 4, 8, P.skin1, 1, 3, 2)
  // Rounded crown and arched fringe soften both the scalp and forehead silhouette.
  rect(bx - 9, by + 1, 18, 2, P.hair1)
  rect(bx - 12, by + 3, 24, 3, P.hair1)
  rect(bx - 15, by + 6, 30, 4, P.hair0)
  rect(bx - 13, by + 9, 6, 8, P.hair0)
  rect(bx - 8, by + 8, 7, 5, P.hair1)
  rect(bx - 2, by + 7, 8, 4, P.hair1)
  rect(bx + 6, by + 8, 8, 7, P.hair0)
  rect(bx - 7, by + 3, 13, 2, P.hair2)
  characterDitherRect(bx - 12, by + 4, 24, 6, P.hair2, 2, 2, 1)
  // Tapered side locks echo the jaw instead of boxing it in.
  rect(bx - 13, by + 20, 3, 8, P.hair1)
  rect(bx - 11, by + 28, 3, 5, P.hair1)
  rect(bx + 12, by + 19, 3, 9, P.hair0)
  rect(bx + 10, by + 28, 3, 5, P.hair1)
  // Coral island-shaped hair clip.
  rect(bx + 10, by + 6, 5, 3, P.coral)
  rect(bx + 12, by + 4, 2, 2, P.coral)

  const blink = Math.floor(t / 2700) % 5 === 4 && (t % 2700) < 130
  if (blink) {
    rect(bx - 7, by + 20, 5, 1, P.hair0)
    rect(bx + 5, by + 20, 5, 1, P.hair0)
  } else {
    rect(bx - 7, by + 18, 4, 4, P.white)
    rect(bx + 6, by + 18, 4, 4, P.white)
    rect(bx - 5, by + 19, 2, 3, P.ink)
    rect(bx + 6, by + 19, 2, 3, P.ink)
    rect(bx - 8, by + 17, 2, 1, P.hair0)
    rect(bx + 10, by + 17, 2, 1, P.hair0)
  }
  rect(bx - 1, by + 25, 5, 1, P.skin0)
  if (action === 'talk') {
    rect(bx, by + 27, 4, 2, P.ink)
    rect(bx + 1, by + 28, 2, 1, P.coral)
  } else {
    rect(bx, by + 27, 4, 1, P.skin0)
  }
  // Slender neck connects the pointed chin to the sailor collar.
  rect(bx - 3, by + 36, 8, 5, P.skin1)
  rect(bx - 2, by + 36, 6, 5, P.skin2)

  // Shirt, sailor collar, weatherproof apron.
  rect(bx - 18, by + 37, 38, 51, P.apron0)
  rect(bx - 14, by + 37, 30, 9, P.white)
  rect(bx - 9, by + 39, 20, 6, P.apron2)
  rect(bx - 14, by + 47, 30, 41, P.apron1)
  rect(bx - 11, by + 51, 24, 34, P.apron0)
  rect(bx - 10, by + 54, 22, 3, P.apron2)
  characterDitherRect(bx - 10, by + 58, 22, 25, P.apron1, 1, 2, 3)
  // Shell clasp and tapered waist reinforce the feminine sailor silhouette.
  rect(bx - 4, by + 45, 9, 3, P.coral)
  rect(bx - 2, by + 43, 5, 2, P.lamp)
  rect(bx - 12, by + 65, 2, 13, P.apron1)
  rect(bx + 11, by + 65, 2, 13, P.apron1)
  rect(bx - 8, by + 76, 18, 7, P.wood0)
  rect(bx - 7, by + 77, 16, 5, P.wood2)
  rect(bx - 4, by + 78, 2, 2, P.coral)

  // Arms and props are deliberately frame-like, with no smooth rotation.
  if (shaking) {
    const sy = by + 42 + Math.round(Math.sin(t * .07) * 4)
    rect(bx - 24, by + 40, 13, 6, P.white)
    rect(bx + 13, by + 40, 13, 6, P.white)
    rect(bx - 17, sy, 10, 7, P.skin2)
    rect(bx + 9, sy, 10, 7, P.skin2)
    rect(bx - 8, sy - 5, 18, 15, P.ink)
    rect(bx - 6, sy - 4, 14, 13, '#a8b6b4')
    rect(bx - 5, sy - 3, 12, 2, P.white)
  } else if (stirring) {
    const tap = action === 'muddle' ? Math.round(Math.sin(t * .045) * 4) : 0
    rect(bx - 23, by + 43, 13, 7, P.white)
    rect(bx + 13, by + 43, 14, 7, P.white)
    rect(bx - 17, by + 47, 8, 7, P.skin2)
    rect(bx + 20, by + 47, 8, 7, P.skin2)
    rect(bx + 25 + tap, by + 38, 1, 20, P.brass1)
    rect(bx + 18, by + 57, 16, 3, P.ink)
    rect(bx + 20, by + 59, 12, 10, P.blue1)
  } else if (layering) {
    rect(bx - 23, by + 42, 13, 7, P.white)
    rect(bx + 13, by + 43, 14, 7, P.white)
    rect(bx - 28, by + 38, 9, 8, P.skin2)
    bottle(bx - 35, by + 18, P.honey, P.white, 21)
    rect(bx - 19, by + 44, 1, 14, P.honey)
    rect(bx + 21, by + 57, 13, 3, P.ink)
    rect(bx + 23, by + 60, 9, 9, P.blue1)
    rect(bx + 23, by + 60, 9, 3, P.honey)
  } else if (pouring) {
    const lift = Math.round(Math.sin(progress * Math.PI) * 12)
    rect(bx - 23, by + 42, 12, 7, P.white)
    rect(bx - 28, by + 39 - lift, 9, 8, P.skin2)
    bottle(bx - 35, by + 20 - lift, ingredientColor(ingredientType), P.white, 21)
    rect(bx + 13, by + 43, 14, 7, P.white)
    rect(bx + 22, by + 47, 8, 7, P.skin2)
    if (progress > .4 && progress < .8) rect(bx - 19, by + 47, 1, 10, ingredientColor(ingredientType))
  } else if (serving) {
    const push = Math.round(progress * 42)
    rect(bx - 22, by + 44, 16 + push, 7, P.white)
    rect(bx - 27 + push, by + 47, 9, 7, P.skin2)
  } else {
    rect(bx - 23, by + 43, 11, 29, P.white)
    rect(bx + 14, by + 43, 11, 29, P.white)
    rect(bx - 21, by + 67, 8, 8, P.skin2)
    rect(bx + 15, by + 67, 8, 8, P.skin2)
  }
}

function ingredientColor(type: number) {
  return ({
    1: '#c49a6c', 2: '#d8e8d8', 3: '#f5e6c4', 4: '#b5651d', 5: '#faf0e6',
    6: '#00aaff', 7: '#e8a317', 8: '#fffff0', 9: '#ffd700', 10: '#dc143c',
    11: '#fff44f', 12: '#32cd32', 13: '#ee82ee', 14: '#98ff98', 15: '#ffffff',
    16: '#e0f7fa', 17: '#fff44f', 18: '#ffe135', 19: '#9b111e', 20: '#d4af37',
  } as Record<number, string>)[type] || P.blue2
}

function drawMermaidTailTip(t: number) {
  const tailX = Math.round(Math.sin(t * .0025) * 2) - 5
  const tailY = Math.round(Math.sin(t * .0031 + 1.2) * 2)
  // Uneven stepped offsets form a soft hook: upright at the base, then bending right.
  rect(250 + tailX, 99 + tailY, 14, 9, P.tail0)
  rect(253 + tailX, 95 + tailY, 13, 9, P.tail1)
  rect(257 + tailX, 91 + tailY, 11, 8, P.tail1)
  rect(262 + tailX, 87 + tailY, 9, 8, P.tail1)
  rect(268 + tailX, 83 + tailY, 7, 8, P.tail2)
  rect(273 + tailX, 80 + tailY, 5, 7, P.tail2)
  // A medium-density scale transition follows the tail's own x/y motion.
  characterDitherRect(250 + tailX, 99 + tailY, 14, 9, P.tail1, 2, 0, 1)
  characterDitherRect(253 + tailX, 95 + tailY, 13, 8, P.tail2, 2, 2, 3)
  characterDitherRect(257 + tailX, 91 + tailY, 11, 7, P.tail2, 2, 1, 0)
  // Shadow and glint make the stepped silhouette read as a rounded, scaled surface.
  rect(251 + tailX, 103 + tailY, 11, 3, P.tail0)
  rect(257 + tailX, 96 + tailY, 7, 2, P.tail0)
  rect(263 + tailX, 89 + tailY, 5, 2, P.tail2)
  // The split fin follows the tangent of the curve instead of a rigid diagonal axis.
  rect(274 + tailX, 78 + tailY, 8, 9, P.tail1)
  rect(272 + tailX, 73 + tailY, 8, 8, P.tail1)
  rect(272 + tailX, 69 + tailY, 6, 6, P.tail2)
  rect(280 + tailX, 84 + tailY, 8, 7, P.tail1)
  rect(286 + tailX, 88 + tailY, 6, 6, P.tail2)
  characterDitherRect(274 + tailX, 78 + tailY, 8, 9, P.tail2, 2, 2, 1)
  characterDitherRect(280 + tailX, 84 + tailY, 8, 7, P.tail2, 2, 0, 3)
}

function drawBarStool() {
  // A single guest seat in the foreground gives the viewer a place inside the scene.
  rect(43, 140, 35, 4, P.ink)
  rect(45, 136, 31, 7, P.wood3)
  rect(48, 134, 25, 3, P.wood2)
  rect(49, 143, 5, 32, P.brass0)
  rect(68, 143, 5, 32, P.brass0)
  rect(51, 145, 2, 29, P.brass1)
  rect(70, 145, 2, 29, P.brass1)
  rect(51, 164, 21, 3, P.brass0)
  rect(47, 175, 10, 3, P.ink)
  rect(65, 175, 10, 3, P.ink)
}

function drawCounter(t: number) {
  rect(0, 106, 320, 7, P.ink)
  rect(0, 113, 320, 39, P.wood2)
  rect(0, 116, 320, 4, P.wood3)
  rect(0, 121, 320, 2, P.wood1)
  for (let x = 6; x < 320; x += 31) rect(x, 136 + (x % 3), 22, 2, P.wood1)
  rect(0, 152, 320, 28, P.wood0)
  rect(0, 152, 320, 3, P.brass0)
  ditherRect(0, 123, 320, 29, P.wood1, 2, 1, 2)
  ditherRect(0, 155, 320, 25, P.wood1, 1, 3, 1)
  // Closed wooden frontage with repeated brass-trimmed panels.
  for (let x = 8; x < 320; x += 52) {
    rect(x, 126, 42, 21, P.wood1)
    rect(x + 2, 128, 38, 2, P.wood3)
    rect(x + 2, 143, 38, 2, P.wood0)
  }
  rect(28, 102, 28, 5, P.ink)
  rect(31, 96, 22, 7, '#879896')
  rect(34, 93, 16, 4, P.white)

  if (action === 'serve' || action === 'result') drawDrink(t)
}

function drawDrink(t: number) {
  const serveProgress = action === 'serve' ? Math.min(1, (t - actionStartedAt) / actionDuration) : 1
  const x = Math.round(196 - serveProgress * 94)
  const y = 96
  const palette = recipes[props.recipe?.id || 2] || recipes[2]
  const liquid = props.appearance?.color || palette.liquid
  rect(x - 1, y, 18, 3, P.ink)
  rect(x, y + 2, 16, 17, '#b8d1cc')
  rect(x + 2, y + 4, 12, 13, liquid)
  if ((props.appearance?.texture || '') === 'layered' || props.recipe?.id === 2) {
    rect(x + 2, y + 4, 12, 5, palette.accent)
    rect(x + 2, y + 9, 12, 8, liquid)
  }
  rect(x + 4, y + 5, 2, 8, P.white)
  rect(x + 7, y + 19, 2, 6, '#b8d1cc')
  rect(x + 3, y + 25, 10, 2, P.ink)
  rect(x + 4, y + 24, 8, 2, '#b8d1cc')
  if (props.recipe?.id === 3) {
    rect(x + 12, y + 1, 5, 2, P.green)
    rect(x + 14, y - 2, 2, 4, P.green)
  }
  if (action === 'result' && Math.floor(t / 240) % 3 === 0) {
    rect(x - 5, y + 4, 2, 2, P.lamp)
    rect(x + 20, y + 10, 1, 3, P.blue2)
  }
}

function drawPendantLighting() {
  if (!context) return
  const daylight = daylightAmount()
  const lampStrength = props.barMode === 'open' ? 1 : props.barMode === 'stocking' ? .68 : .08
  context.save()
  context.globalCompositeOperation = 'screen'

  // Window light fills the closed daytime room; pendants take over after dusk.
  context.globalAlpha = .055 * daylight
  context.fillStyle = '#78aeb1'
  context.fillRect(0, 0, 320, 180)
  context.restore()

  // Pixel pendant fixtures are drawn after the glow so their edges stay crisp.
  for (const [x, length] of [[96, 9], [224, 9]] as Array<[number, number]>) {
    rect(x - 1, 0, 2, length, P.brass0)
    rect(x - 4, length, 8, 2, P.wood0)
    rect(x - 7, length + 2, 14, 3, P.brass1)
    rect(x - 4, length + 5, 8, 3, lampStrength > .2 ? P.lamp : P.brass0)
    rect(x - 2, length + 8, 4, 2, lampStrength > .2 ? '#fff0bd' : P.wall2)
  }
}

function drawAmbient(t: number) {
  rect(0, 0, 320, 180, P.ink)
  ditherRect(0, 0, 320, 180, P.ink2, 1, 2, 3)
  drawWindow(t)
  drawBackBar()
  if (props.bartenderPresent) drawTranslatedIslander(t)
  drawCounter(t)
  drawBarStool()
  drawPendantLighting()
  rect(4, 164, 5, 5, P.coral)
  rect(11, 165, 1, 3, P.lamp)
  pixelText('海浪之歌酒吧', 124, 163, P.brass1)
}

function render(t: number) {
  if (!context) return
  if (resultQueued && t >= actionStartedAt + actionDuration) {
    resultQueued = false
    action = 'result'
    actionStartedAt = t
    actionDuration = 900
  }
  context.imageSmoothingEnabled = false
  drawAmbient(t)
  frame++
  raf = requestAnimationFrame(render)
}

watch(() => props.cue, (cue) => {
  if (!cue) {
    action = 'idle'
    resultQueued = false
    actionStartedAt = performance.now()
    return
  }
  const now = performance.now()
  resultQueued = false
  if (cue.type === 'order.accepted') {
    action = 'accept'
    actionStartedAt = now
    actionDuration = 900
  } else if (cue.type === 'bartender.say') {
    action = ({ opening: 'accept', ingredient: 'talk', technique: 'talk', serving: 'serve' } as Record<string, string>)[cue.payload.stage] || 'talk'
    actionStartedAt = now
    actionDuration = cue.payload.stage === 'opening' ? 1800 : cue.payload.stage === 'serving' ? 1500 : 900
  } else if (cue.type === 'action.start') {
    action = 'ingredient'
    ingredientType = cue.payload.type_id || 0
    const color = ingredientColor(ingredientType)
    islanderBottleSprite = createIslander6Sprite(color)
    islanderItemSprite = createIslander7Sprite(color)
    actionStartedAt = now
    actionDuration = cue.payload.duration_ms || 1200
  } else if (cue.type === 'action.technique') {
    action = ({ '摇和': 'shake', '搅和': 'stir', '捣压': 'muddle', '分层': 'layer' } as Record<string, string>)[cue.payload.technique] || 'shake'
    actionStartedAt = now
    actionDuration = cue.payload.duration_ms || 3200
  } else if (cue.type === 'order.completed') {
    // The server sends completion immediately after the serving line. Preserve
    // the short push-the-glass performance before switching to the result pose.
    if (action === 'serve') resultQueued = true
    else {
      action = 'result'
      actionStartedAt = now
      actionDuration = 900
    }
  } else if (cue.type === 'order.failed') {
    action = 'failed'
    actionStartedAt = now
    actionDuration = 900
  }
})

onMounted(() => {
  context = canvas.value?.getContext('2d', { alpha: false }) || null
  islanderSprite = createIslander3Sprite()
  islanderLayerSprite = createIslander4LayerBaseSprite()
  islanderLayerHandLayer = createIslander4HandLayer()
  islanderStirSprite = createIslander5Sprite()
  islanderStirHandLayer = createIslander5HandLayer()
  islanderShakeSprite = createIslander8ShakeBaseSprite()
  islanderShakeHandLayer = createIslander8ShakeHandLayer()
  islanderBottleSprite = createIslander6Sprite(ingredientColor(1))
  islanderItemSprite = createIslander7Sprite(ingredientColor(11))
  startedAt = performance.now()
  actionStartedAt = startedAt
  raf = requestAnimationFrame(render)
})

onBeforeUnmount(() => cancelAnimationFrame(raf))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref_key: "canvas",
      ref: canvas,
      width: "320",
      height: "180",
      "aria-label": "水蓝色长发的岛民娘，在台风夜里的海浪之歌酒吧调酒"
    }, null, 512),
    _hoisted_2,
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(["lamp-light-overlay", __props.barMode]),
      viewBox: "0 0 320 180",
      preserveAspectRatio: "xMidYMid meet",
      "aria-hidden": "true"
    }, _hoisted_4, 2))
  ]))
}
}

})